import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Download from '@/components/Download'
import Launcher from '@/components/Launcher'
import Browser from '@/components/Browser'

Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/download',
      name: 'Download',
      component: Download
    },
    {
      path: '/launcher',
      name: 'Launcher',
      component: Launcher
    },
    {
      path: '/browser',
      name: 'Browser',
      component: Browser
    },
  ]
})
export default router

router.beforeEach((to, from, next) => {
  let currentURL = window.location.href
  let bla = currentURL.substring(currentURL.length - 2, currentURL.length)
  console.log("## BLA", bla)
  console.log("## currentURL=", currentURL)
  if (bla === '#/'){
    currentURL = currentURL.substring(0, currentURL.length - 2)
  }
  let newURL = currentURL
  if (window.location.href.includes("/launcher/")  && window.location.href.indexOf("/#/") == -1) {
    newURL= newURL.replace('/launcher/', '/#/launcher')
    window.location.replace(newURL)
  }
  else if (window.location.pathname == '/launcher' && window.location.href.indexOf("/#/") == -1) {
    newURL= newURL.replace('/launcher', '/#/launcher')
    window.location.replace(newURL)
  }
  else if (window.location.pathname == '/browser' && window.location.href.indexOf("/#/") == -1) {
    newURL= newURL.replace('/browser', '/#/browser')
    window.location.replace(newURL)
  }
  else if (window.location.pathname == '/download' && window.location.href.indexOf("/#/") == -1) {
    newURL= newURL.replace('/download', '/#/download')
    window.location.replace(newURL)
  }

  
  if (window.location.protocol !== 'https:' && !window.location.href.includes('localhost')) {
    window.location.protocol = 'https:'
    window.location.replace(window.location.href)
  } else if (bla === '#/') {
    if (navigator.appName === 'Microsoft Internet Explorer' || !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/))) {
      next()
    } else {

      let url = new URL(window.location.href)
      if (url.searchParams.get('meetingID') && url.searchParams.get('name')) {
        if(url.searchParams.get('pin') && url.searchParams.get('pin') === 'required'){
          let newURL = currentURL.substring(0, currentURL.length - 2)
        //  newURL = newURL.replace('/?', '/#/?')
      //    window.location.replace(newURL)
        } else {
          let newURL = currentURL.substring(0, currentURL.length - 2)
        //  newURL = newURL.replace('/?', '/#/startMeeting?')
        //  window.location.replace(newURL)
        }
      } else if (url.searchParams.get('meetingID') || url.searchParams.get('branding')) {
        let newURL = currentURL.substring(0, currentURL.length - 2)
      //  newURL = newURL.replace('/?', '/#/?')
      //  window.location.replace(newURL)
      } else {
        next()
      }
    }
  } else {

    next()
  }
  
})



// WEBPACK FOOTER //
// ./src/router/index.js